import React, { useEffect, useRef, useState } from "react";
import UserFilterComponant from "../../components/UserFilterComponant/UserFilterComponant";
import ThemeCard from "../../components/ThemeCard";
import { Button, Col, Modal, Pagination, Row, Table, notification, Tag } from "antd";
import styled from "styled-components";
import ThemeCardTable from "../../components/ThemeCardTable";
import { PaginationRow, StyledButton } from "../../styles/commonStyle";
import { useQuery } from "@tanstack/react-query";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";
import useGetQueryParams from "../../hooks/useGetQueryParams";
import { useDispatch, useSelector } from "react-redux";
import { setUserClearFilter } from "../../store/slice/globleSlice";
import { formatToINRForSummay } from "../../components/FormateToINR/formatToINR";

const StyTable = styled(Table)`
  transform: none !important;
  & .ant-table-thead tr .ant-table-cell {
    background-color: ${(props) => props.theme.token.colorPrimary};
    color: ${(props) => props.theme.token.colorTextLightSolid};
    font-size: 0.9rem;
    font-weight: 500;
  }
  @media screen and (max-width: 1079px) {
    .ant-table-thead tr .ant-table-cell {
      font-size: 0.75rem;
    }
  }
  .ant-table-thead tr .ant-table-cell::before {
    display: none;
  }

  .ant-table-thead tr .ant-table-cell .ant-table-column-has-sorters {
    border-top: ${(props) =>
      `1px solid ${props.theme.token.colorBorder} !important`};
  }
  .ant-table-body .ant-table-cell {
    border-bottom: 0px;
  }

  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 0.5rem !important;
  }
  .ant-table-thead tr th {
    height: 2rem !important;
    padding: 0rem 0.5rem !important;
  }
  .collapseTable .ant-collapse-expand-icon span svg {
    fill: ${(props) => props.theme.token.colorTextLightSolid} !important;
  }
  .collapseTable .ant-collapse-header-text {
    color: ${(props) => props.theme.token.colorTextLightSolid};
  }

  .ant-switch-checked .ant-switch-inner {
    background-color: ${(props) =>
      props.theme.token.colorBgActionButton} !important;
  }

  .ant-table-thead {
    height: 3.18rem;
  }

  .ant-table-thead .ant-table-cell {
    &:hover {
      background: ${(props) =>
        props.theme.token.colorPrimaryBgHover} !important;
    }
  }
  .ant-table-body .ant-table-cell {
    padding: 0.5rem !important;
  }

  .ant-table-tbody .ant-table-row:hover {
    background: #f5f5f5;
  }

  .ant-table-tbody .highlighted-row {
    background-color: #edecfa;
  }
`;

const EditButton = styled(Button)`
  border-radius: ${(props) => props.theme.token?.borderRadiusLG};
  font-size: 1rem;
  background-color: ${(props) => props.theme.token?.colorPrimary};
  box-shadow: ${(props) => props.theme.token?.boxShadowNone};
  color: white;
`;

let converterObj = {
  basicInfo: "Basic Info",
  accountDetails: "Account Details",
  additionalInfo: "Additional Info",
  brokerageDetails: "Brokerage Details",
  margin: "Margin",
  scriptWiseInfo: "Script Wise Info",
  additionalSharing: "Additional Sharing",
  scriptWiseSetting: "Script Wise Setting",
  marketAccess: "Market Access",
};

let ItemsArray = [
  "basicInfo",
  "accountDetails",
  "additionalInfo",
  "brokerageDetails",
  "margin",
  "scriptWiseInfo",
  "additionalSharing",
  "scriptWiseSetting",
  "marketAccess",
];

const UserEditLog = () => {
  // state
  const [showModal, setShowModal] = useState({
    flag: false,
    record: null,
    name: null,
    groupedData: null,
    markets: [],
    selectedMarket: null,
    fullRecord: null, // Store the full log record for market-based grouping
  });
  const [totalCounts, setTotalCounts] = useState(0);

  const valueRef = useRef({});
  const dispatch = useDispatch();
  const { params, setSearchParams } = useGetQueryParams();

  // redux
  const loginId = useSelector((state) => state.authSlice?.userDetail?.userId);

  // life cycle
  useEffect(() => {
    if (!params?.userId) {
      setSearchParams({ userId: loginId });
    }
  }, [params]);

  // api call
  const getUserEditLog = async () => {
    let response = await APICall(
      "get",
      `${EndPoints.getUserEditLog}?userId=${params?.userId || loginId}&page=${
        params?.page || 1
      }&&limit=${params?.limit || 10}`
    );
    setTotalCounts(response?.data?.data?.totalItems);
    return response?.data?.data;
  };

  const { isLoading, error, data } = useQuery({
    queryKey: ["userEditLog", params],
    queryFn: getUserEditLog,
    enabled: Object.keys(params)?.length > 0,
  });

  if (error) notification.error({ message: error?.message });

  // Process data for formatting
  const processData = (data, arrayName) => {
    let processed = data?.map((el) =>
      el?.key === "Expiry Date"
        ? {
            ...el,
            new: valanBillDate(el?.new),
            old: valanBillDate(el?.old),
          }
        : el
    );
    if (arrayName === "margin") {
      processed = processed?.map((el) => ({
        ...el,
        old: formatToINRForSummay(el?.old),
        new: formatToINRForSummay(el?.new),
      }));
    }
    return processed;
  };

  // Handle viewing by market (across all arrays)
  const handleViewByMarket = (record, selectedMarket = null) => {
    // Arrays that can have marketName
    const marketArrays = ["marketAccess", "brokerageDetails", "margin", "scriptWiseInfo", "scriptWiseSetting"];
    
    // Collect all unique markets across all arrays
    const marketsSet = new Set();
    const marketDataMap = {}; // { marketName: { arrayName: [data] } }

    marketArrays.forEach((arrayName) => {
      const arrayData = record[arrayName] || [];
      if (Array.isArray(arrayData) && arrayData.length > 0) {
        arrayData.forEach((item) => {
          const marketName = item?.marketName;
          if (marketName != null && marketName !== "null" && marketName !== "") {
            marketsSet.add(marketName);
            
            if (!marketDataMap[marketName]) {
              marketDataMap[marketName] = {};
            }
            if (!marketDataMap[marketName][arrayName]) {
              marketDataMap[marketName][arrayName] = [];
            }
            marketDataMap[marketName][arrayName].push(item);
          }
        });
      }
    });

    const markets = Array.from(marketsSet);

    if (markets.length > 0) {
      // Process all data for formatting
      Object.keys(marketDataMap).forEach((market) => {
        Object.keys(marketDataMap[market]).forEach((arrayName) => {
          marketDataMap[market][arrayName] = processData(marketDataMap[market][arrayName], arrayName);
        });
      });

      // Use selected market if provided, otherwise use first market
      const marketToShow = selectedMarket || markets[0];
      
      setShowModal({
        flag: true,
        record: null,
        name: "marketView",
        groupedData: marketDataMap,
        markets: markets,
        selectedMarket: marketToShow,
        fullRecord: record,
      });
    } else {
      // No markets found, show error or fallback
      notification.info({ message: "No market data found in this log entry" });
    }
  };

  // Handle viewing specific array (original behavior)
  const handleEdit = (value, name) => {
    let valueData = processData(value, name);

    // Check if data has marketName (not null or undefined)
    const hasMarketName = valueData?.some((item) => item?.marketName != null && item?.marketName !== "null");
    
    if (hasMarketName) {
      // Group data by marketName
      const groupedData = {};
      const markets = [];
      
      valueData?.forEach((item) => {
        // Only group items with valid marketName, others go to "Other"
        const marketName = item?.marketName != null && item?.marketName !== "null" 
          ? item.marketName 
          : "Other";
        if (!groupedData[marketName]) {
          groupedData[marketName] = [];
          if (!markets.includes(marketName)) {
            markets.push(marketName);
          }
        }
        groupedData[marketName].push(item);
      });

      const firstMarket = markets.length > 0 ? markets[0] : null;
      setShowModal({
        flag: true,
        record: firstMarket ? groupedData[firstMarket] : valueData,
        name: name,
        groupedData: groupedData,
        markets: markets,
        selectedMarket: firstMarket,
        fullRecord: null,
      });
    } else {
      // No marketName, show all data as before
      setShowModal({
        flag: true,
        record: valueData,
        name: name,
        groupedData: null,
        markets: [],
        selectedMarket: null,
        fullRecord: null,
      });
    }
  };

  const handleMarketSelect = (marketName) => {
    if (showModal.name === "marketView") {
      // For market view, we don't need to update record as we'll render grouped by array
      setShowModal((prev) => ({
        ...prev,
        selectedMarket: marketName,
      }));
    } else {
      // For single array view
      setShowModal((prev) => ({
        ...prev,
        selectedMarket: marketName,
        record: prev.groupedData[marketName] || [],
      }));
    }
  };

  const handleCancel = () => {
    setShowModal({
      flag: false,
      record: null,
      name: null,
      groupedData: null,
      markets: [],
      selectedMarket: null,
      fullRecord: null,
    });
  };
  const handleSearch = () => {
    let userId = valueRef.current?.userId;
    if (userId) {
      setSearchParams({ userId, page: 1 });
    }
  };
  const onChangePage = (page) => {
    setSearchParams({ ...params, page: page });
  };
  const handleReset = () => {
    valueRef.current = {};
    dispatch(setUserClearFilter(true));
    setSearchParams({ userId: loginId });
  };

  // column
  const columns = [
    {
      title: "CLIENT",
      dataIndex: "client",
      key: "client",
      align: "left",
      width: "5rem",
      render: (text, record) => {
        return <span>{`${record?.accountName} (${record?.userId})`}</span>;
      },
    },
    {
      title: "TYPE",
      dataIndex: "logType",
      key: "logType",
      align: "left",
      width: "5rem",
      render: (text, record) => {
        const type = (record?.logType || "").toUpperCase();
        const color =
          type === "CREATE" ? "green" : type === "DELETE" ? "red" : "blue";
        const label =
          type?.charAt(0) + type?.slice(1)?.toLowerCase(); // Create | Update | Delete
        return <Tag color={color}>{label || "Update"}</Tag>;
      },
    },
    {
      title: "CHANGE LOGS",
      dataIndex: "logs",
      key: "logs",
      align: "left",
      width: "20rem",
      render: (text, record) => {
        // Arrays that don't have marketName
        const nonMarketArrays = ["basicInfo", "accountDetails", "additionalInfo"];
        // Arrays that can have marketName
        const marketArrays = ["marketAccess", "brokerageDetails", "margin", "scriptWiseInfo", "scriptWiseSetting"];
        
        // Collect all unique market names from market arrays
        const marketsSet = new Set();
        marketArrays.forEach((arrayName) => {
          const arrayData = record[arrayName] || [];
          if (Array.isArray(arrayData) && arrayData.length > 0) {
            arrayData.forEach((item) => {
              const marketName = item?.marketName;
              if (marketName != null && marketName !== "null" && marketName !== "") {
                marketsSet.add(marketName);
              }
            });
          }
        });

        const markets = Array.from(marketsSet);

        return (
          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {/* Show buttons for non-market arrays */}
            {nonMarketArrays
              .filter((item) => item in record && record[item]?.length > 0)
              .map((item) => {
                return (
                  <EditButton
                    key={item}
                    type="primary"
                    onClick={() => handleEdit(record[item] || [], item)}
                  >
                    {converterObj[item]}
                  </EditButton>
                );
              })}
            
            {/* Show market name buttons */}
            {markets.map((market) => (
              <EditButton
                key={market}
                type="primary"
                onClick={() => handleViewByMarket(record, market)}
                style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
              >
                {market}
              </EditButton>
            ))}
          </div>
        );
      },
    },
    {
      title: "TIME",
      dataIndex: "time",
      key: "time",
      width: "5rem",
      align: "left",
      render: (text, record) => {
        const time = valanBillDate(record?.updateTime, true);
        return <div>{time}</div>;
      },
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      key: "updatedBy",
      width: "5rem",
      align: "left",
      render: (text, record) => {
        return (
          <div>{`${record?.updatedBy?.accountName}(${record?.updatedBy?.userId})`}</div>
        );
      },
    },
    {
      title: "IP",
      dataIndex: "ipAddress",
      key: "ip",
      width: "5rem",
      align: "left",
    },
  ];

  // Helper function to format null values
  const formatNullValue = (value) => {
    if (value === null || value === undefined || value === "null" || value === "NULL" || value === "") {
      return "-";
    }
    return value;
  };

  // Helper function to check if value is numeric
  const isNumeric = (value) => {
    if (value === "-" || value === null || value === undefined) return false;
    const num = parseFloat(value);
    return !isNaN(num) && isFinite(num);
  };

  // Helper function to format old -> new value display with colors
  const formatValueChange = (oldValue, newValue) => {
    const formattedOld = formatNullValue(oldValue);
    const formattedNew = formatNullValue(newValue);
    
    // If old value is null/empty or both values are same, show only new value in green
    if (formattedOld === "-" || formattedOld === formattedNew) {
      return (
        <span style={{ color: "#52c41a", fontWeight: 500, fontSize: "1rem" }}>
          {formattedNew}
        </span>
      );
    }
    
    // Check if values are numeric to determine increase/decrease
    const isOldNumeric = isNumeric(formattedOld);
    const isNewNumeric = isNumeric(formattedNew);
    
    let oldColor = "#ff4d4f"; // Default red
    let newColor = "#52c41a"; // Default green
    
    // If both are numeric, determine colors based on increase/decrease
    if (isOldNumeric && isNewNumeric) {
      const oldNum = parseFloat(formattedOld);
      const newNum = parseFloat(formattedNew);
      
      if (newNum > oldNum) {
        // Increased: red (old) -> green (new)
        oldColor = "#ff4d4f";
        newColor = "#52c41a";
      } else if (newNum < oldNum) {
        // Decreased: green (old) -> red (new)
        oldColor = "#52c41a";
        newColor = "#ff4d4f";
      }
    }
    
    // Show old -> new without strikethrough
    return (
      <span style={{ fontSize: "1rem" }}>
        <span style={{ color: oldColor, marginRight: "0.5rem", fontWeight: 500 }}>
          {formattedOld}
        </span>
        <span style={{ color: "#8c8c8c", margin: "0 0.5rem" }}>→</span>
        <span style={{ color: newColor, fontWeight: 500 }}>
          {formattedNew}
        </span>
      </span>
    );
  };

  const generateRecordColumns = (record, showMarketName = false) => {
    let baseColumns = [
      {
        title: "Key",
        dataIndex: "key",
        key: "client",
        align: "left",
        render: (text) => formatNullValue(text),
      },
      {
        title: "Value",
        dataIndex: "value",
        key: "value",
        align: "left",
        render: (text, record) => formatValueChange(record?.old, record?.new),
      },
    ];

    // Only show Market Name column if not grouped (when grouped, we show buttons instead)
    if (showMarketName && record && record[0]?.marketName) {
      baseColumns.unshift({
        title: "Market Name",
        dataIndex: "marketName",
        key: "marketName",
        align: "left",
        render: (text) => formatNullValue(text),
      });
    }

    return baseColumns;
  };

  return (
    <>
      <ThemeCard>
        <Row gutter={[20, 20]}>
          <UserFilterComponant valueRef={valueRef} />
        </Row>
        <Row style={{ marginTop: "3rem" }} gutter={[10, 10]}>
          <Col xs={24} sm={12} md={8} lg={3} xl={2}>
            <StyledButton type="primary" onClick={handleSearch}>
              Search
            </StyledButton>
          </Col>
          <Col xs={24} sm={12} md={8} lg={3} xl={2}>
            <StyledButton type="primary" onClick={handleReset}>
              Reset
            </StyledButton>
          </Col>
        </Row>
      </ThemeCard>

      <ThemeCardTable
        column={columns}
        buttonType={false}
        data={data?.data}
        isLoading={isLoading}
        filtertype="editLogs"
      />
      <PaginationRow align={"center"}>
        <Pagination
          size="large"
          showSizeChanger={false}
          current={params?.page || 1}
          pageSize={params?.limit || 10}
          total={totalCounts}
          onChange={onChangePage}
        />
      </PaginationRow>
      <Modal
        title={
          showModal?.name === "marketView" 
            ? `${showModal?.selectedMarket || "Market"} - Changes`
            : converterObj[showModal?.name]
        }
        open={showModal?.flag}
        onCancel={handleCancel}
        footer={false}
        width={1200}
      >
        {showModal?.markets && showModal.markets.length > 0 && (
          <div style={{ marginBottom: "1rem", display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            {showModal.markets.map((market) => (
              <Button
                key={market}
                type={showModal.selectedMarket === market ? "primary" : "default"}
                onClick={() => handleMarketSelect(market)}
                style={{ marginBottom: "0.5rem" }}
              >
                {market}
              </Button>
            ))}
          </div>
        )}
        
        {showModal?.name === "marketView" && showModal?.selectedMarket && showModal?.groupedData ? (
          // Render grouped by array type for selected market
          <div>
            {Object.keys(showModal.groupedData[showModal.selectedMarket] || {}).map((arrayName) => {
              const arrayData = showModal.groupedData[showModal.selectedMarket][arrayName] || [];
              if (arrayData.length === 0) return null;
              
              return (
                <div key={arrayName} style={{ marginBottom: "2rem" }}>
                  <h3 style={{ marginBottom: "0.5rem", fontSize: "1.1rem", fontWeight: 600 }}>
                    {converterObj[arrayName] || arrayName}
                  </h3>
                  <StyTable
                    className="userTable"
                    bordered
                    columns={generateRecordColumns(arrayData, false)}
                    dataSource={arrayData}
                    pagination={false}
                    rowKey={(record, index) => `${arrayName}-${record?.key}-${index}`}
                    scroll={{
                      x: 600,
                    }}
                    rowClassName={(record) =>
                      record.key === "Script Name" || record.key === "Broker Id"
                        ? "highlighted-row"
                        : ""
                    }
                  />
                </div>
              );
            })}
          </div>
        ) : (
          // Original single table view
          <StyTable
            className="userTable"
            bordered
            columns={generateRecordColumns(
              showModal?.record,
              !showModal?.markets || showModal.markets.length === 0
            )}
            dataSource={showModal?.record}
            pagination={false}
            rowKey={(record, index) => `${record?.key}-${record?.marketName || ""}-${index}`}
            scroll={{
              x: 600,
            }}
            rowClassName={(record) =>
              record.key === "Script Name" || record.key === "Broker Id"
                ? "highlighted-row"
                : ""
            }
          />
        )}
      </Modal>
    </>
  );
};

export default UserEditLog;
